import React from 'preact';
import { Link, Match } from 'preact-router/match';

export default class Header extends React.Component {
  /**
   * Returns a clickable link element. preact-router's Link element adds 'active' to the classname
   * when the path contains the href of the Link. When the path is the root '/' path, we default to
   * showing the /about page and the Link component doesn't show this as active. To cover this case,
   * pass in active=true to add the 'active' class.
   * @param {*} link string or an object
   *   {
   *     linkName: '<link-name>',
   *     linkText: '<link-text>'
   *   }
   * @param {*} active
   */
  getLink(link, active) {
    const { linkName, linkText } = link;
    return (
      <li className="section-link" key={linkName}>
        <Link
          className={`link ${active ? 'active' : ''}`}
          activeClassName="active"
          href={`/${linkName}`}
        >
          {linkText}
        </Link>
      </li>
    );
  }

  /**
   * @param {boolean} isRootPath, whether we are currently rendering a root '/' path
   */
  renderLinks(isRootPath) {
    const links = [];

    // when path is '/', allow [about] link to be active
    links.push(
      this.getLink({ linkName: 'about', linkText: 'about' }, isRootPath)
    );

    [
      { linkName: 'skills', linkText: 'skills' },
      { linkName: 'likes', linkText: 'likes' },
      { linkName: 'blog', linkText: 'thoughts' },
      { linkName: 'contact', linkText: 'contact' }
    ].forEach(link => {
      links.push(
        this.getLink(link, location.pathname.indexOf(`/${link.linkName}`) === 0)
      );
    });

    return <ul className="header-right">{links}</ul>;
  }

  render() {
    return (
      <div className="header-container">
        <div className="header">
          <div className="whats-mah-name">Gen Edwards</div>
          {/* when the path is the root '/' path, `matches` is true */}
          <Match path="/">{({ matches }) => this.renderLinks(matches)}</Match>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/components/Header.jsx